import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { FormsService } from '../../services/forms.service';
import * as jwt_decode from 'jwt-decode';
import { CreatefolderforFormComponent } from 'src/app/middleware/common/createfolderforForm/createfolderforForm.component';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { EditfolderforFormComponent } from 'src/app/middleware/common/editfolderforForm/editfolderforForm.component';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormTypes, ProjectTempType, RoleLevel } from '../../services/form.enum';
import { MovetoFormComponent } from 'src/app/middleware/common/movetoForm/movetoForm.component';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})

export class LeftMenuComponent implements OnInit {
  currentUser: any;
  organizationId: string;
  databaseId:string;
  responseHolder: any;
  FormFolderList:any;
  menuHeader: any = [];
  parentID: any;
  ShowCreateButton: boolean;
  FormFolderListWithFolderArray: any;
  FormsubFolderFolderList: any;
  breadCrumMenu: any=[];
  clickEventsubscriptiongetRefreshListForForm: Subscription;
  clickEventsubscriptiongetTotalInbox: Subscription;
  hierarchyList: any;
  showLocalPanel:boolean = false;
  selectedRecordDeleteArray: any = [];
  selectedFolderID: number=0;
  clickEventsubscriptionFromLeftMenu: Subscription;
  rememberNodeArray: any=[];
  totalInbox:number=0;
  activeNode:string="";
  firstElement:any;
  
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  }; 
  SharedWithMeFormFolderList: any;
  SharedWithMeactive:boolean=false;
  Formsactive:boolean = true;
  showForms:boolean = false;
  OfficeIDList: any=[];
  myOfficeID: any;
  categoryList: any[] = [];
  masterTemplateList: any[] = [];
  OrganizationTemplateList: any[] = [];
  selectedCategoryID:any="0";
  rolesAsssign: any[] = [];
  ShowMasterTemplate:boolean=false;
  ShowGlobalTemplateDelete:boolean=false;
  ShowOrgGlobalTemplateDelete:boolean=false;
  ShowOrganizationTemplateDelete:boolean=false;
  isOrganizationAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService, private formService: FormsService,
    private router: Router, private statusConstant: StatusConstant,private dialog: MatDialog,
    private _dataSharingService: DataSharingService,private loaderService: LoaderService) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }
   
  ngOnDestroy() {
    this.clickEventsubscriptiongetRefreshListForForm.unsubscribe();
    this.clickEventsubscriptiongetTotalInbox.unsubscribe();          
  }

   ngOnInit(): void {
    if(environment.production) {      
      this.showLocalPanel=false;
    }else{     
     this.showLocalPanel=true;
    }       

    // this.clickEventsubscription = this._dataSharingService.getRefreshListForFileManager().subscribe((result) => {
    //   if (result != "" && result != undefined) {       
    //     this.getFormFolderList();       
    //   }
    // });
    this.clickEventsubscriptiongetRefreshListForForm = this._dataSharingService.getRefreshListForForm().subscribe((result) => {
      if (result != "" && result != undefined) {       
        this.getFormFolderList();  
      }
    });
    // this.clickEventsubscriptionFromLeftMenu = this._dataSharingService.GetSelectedFolderIDFromLeftMenuToDashBoardFileManager().subscribe((result) => {
    //   if (result != "" && result != undefined) {       
    //     this.selectedFolderID=result;
    //   }
    // });
    this.clickEventsubscriptiongetTotalInbox = this._dataSharingService.getTotalInbox().subscribe((result) => {
      if (result != '' && result != undefined) {
        this.totalInbox = result;
      }else{
        this.getInboxProjects(this.pageModelData);
      }
    });
    //sessionStorage.setItem('esignatureMenuActive','true');
    //sessionStorage.setItem('esignatureMenuSharedActive','false');
    var status= sessionStorage.getItem('esignatureMenuActive');
    if(status=="true"){
      this.Formsactive=true;
      this.SharedWithMeactive=false;
      sessionStorage.setItem('esignatureMenuSharedActive','false');
    }else{
      this.Formsactive=false;
      this.SharedWithMeactive=false;
    }
    var status= sessionStorage.getItem('esignatureMenuSharedActive');
    if(status=="true"){
      this.SharedWithMeactive=true;
      this.Formsactive=false;
    }else{
      this.SharedWithMeactive=false;
    }

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if(this.rolesAsssign.length > 0){
      var role=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin
      || m.roleLevel == RoleLevel.OrganizationAdmin);
      if(role.length > 0){
       this.ShowMasterTemplate = true;
      }else{
        this.ShowMasterTemplate = false;
      }

      var ForGlobalTemp=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      ForGlobalTemp= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(ForGlobalTemp.length > 0){
       this.ShowGlobalTemplateDelete = true;
      }else{
        this.ShowGlobalTemplateDelete = false;
      }

     

      var ForOrgTemp=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      ForOrgTemp= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin);
      if(ForOrgTemp.length > 0){
       this.ShowOrganizationTemplateDelete = true;
      }else{
        this.ShowOrganizationTemplateDelete = false;
      }
    }

    this.getFormFolderList();
    //this.getFormFolderSharedWithMeList();    
  }


  getInboxProjects(pageData: any) {
    var rqModel = {
      pageIndex:this.pageModelData.pageIndex,
      pageSize:this.pageModelData.pageSize,
      searchKey:this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID,
    }   
    this.formService.getInboxProjects(rqModel).subscribe(response=>{
     if(response.data!=null){
       this.totalInbox = response.data.totalItemsToSign;
     }
     else{
     }
    });   
  }


  getFormFolderList() { 
    var rqModel ={
      formFolderID:0,
      formFolderName:"",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID:Number(this.databaseId),
    }
    this.formService.getFormFolderList(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          this.FormFolderList = this.responseHolder.data;          
          if(this.FormFolderList.length>0){
            this.dataSource.data = this.FormFolderList;
            this.firstElement = this.dataSource.data[0];
            if(this.rememberNodeArray.length>0){
              this.rememberNodeArray.forEach(e => {
                document.getElementById(e).click();
              });
            }           
          }         
        }
        else {
        }
      }
      else {
      }
    });
  
  }

  // getFormFolderSharedWithMeList() { 
  //   var rqModel ={
  //     formFolderID:0,
  //     formFolderName:"",
  //     userID:this.currentUser.UID,
  //     organizationID:Number(this.organizationId),
  //     databaseID:Number(this.databaseId),
  //   }
  //   this.formService.getFormFolderSharedWithMeList(rqModel).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
  //         if(this.responseHolder.data!=null){
  //           this.responseHolder.data.forEach(e => {
  //             e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
  //           });
  //         }
  //         this.SharedWithMeFormFolderList = this.responseHolder.data;
  //         if(this.SharedWithMeFormFolderList.length>0){
  //           this.dataSourceSharedWitMe.data = this.SharedWithMeFormFolderList;   
  //         }                 
  //       }
  //       else {
  //       }
  //     }
  //     else {
  //     }
  //   });
  
  // }

  // getFormFolderWithFormTemplatesSharedWithMe(form){
  //   this.selectedFolderID=Number(form.formFolderID);
  //   var rqModel ={      
  //     formFolderID:form.id,
  //     formFolderName:"",
  //     userID:this.currentUser.UID,
  //     organizationID:Number(this.organizationId),
  //     databaseID:Number(this.databaseId),
  //   }
  //   this.formService.getFormFolderWithFormTemplatesSharedWithMe(rqModel).subscribe(res => {
  //     if (res != undefined) {
  //       this.responseHolder = res;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {  
  //         if(this.responseHolder.data!=null){
  //           this.responseHolder.data.forEach(e => {
  //             e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
  //           });
  //         }        
  //          this.FormsubFolderFolderList = this.responseHolder.data;
  //          this.formService.GetParentFormFolderHierarchy(rqModel).subscribe(response => {
  //           if (response != undefined) {
  //             if (response.status == this.statusConstant.statusSuccess) {
  //               this.hierarchyList = response.data.hierarchy;
  //               if(this.hierarchyList == null || this.hierarchyList == undefined){                
  //                 this.breadCrumMenu=[];                 
  //                 var folderDetails ={      
  //                  breadCrumMenu:this.breadCrumMenu,
  //                  FormsubFolderFolderList:this.FormsubFolderFolderList,
  //                  formFolderID:form.formFolderID,
  //                 }
  //                this._dataSharingService.sendSelectedFolderContentFromLeftMenu(folderDetails);
  //                this.parentID = form.parentID;              
  //                this.ShowCreateButton=true;  
  //               }else{
  //                 this.breadCrumMenu=[];
  //                 this.hierarchyList.forEach(e => {
  //                  this.breadCrumMenu.push({ label: e.formFolderName,id:e.formFolderID,icon: 'navigate_next' });
  //                 });
  //                 var folderDetails ={      
  //                  breadCrumMenu:this.breadCrumMenu,
  //                  FormsubFolderFolderList:this.FormsubFolderFolderList,
  //                  formFolderID:form.formFolderID,
  //                 }
  //                this._dataSharingService.sendSelectedFolderContentFromLeftMenu(folderDetails);
  //                this.parentID = form.parentID;              
  //                this.ShowCreateButton=true; 
  //               }                       
  //             }              
  //           }           
  //         });      
  //       }
  //       else {        
  //       }
  //     }
  //     else {      
  //     }
  //   });  
  // }

 

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID:node.formFolderID,
      parentID:node.parentID,
      level: level,
      isShared:node.isShared
    };
  }

  private _transformerSharedWithMe = (node: FoodNodeSharedWithMe, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      id:node.id,
      parentID:node.parentID,
      permissionType:node.permissionType,
      level: level,     
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeControlSharedWithme = new FlatTreeControl<ExampleFlatNodeharedWithMe>(node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  treeFlattenerSharedWithme = new MatTreeFlattener(this._transformerSharedWithMe, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  dataSourceSharedWitMe = new MatTreeFlatDataSource(this.treeControlSharedWithme,this.treeFlattenerSharedWithme);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  close() {
    this.dialog.closeAll();
  }
  
   drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }

  rememberNode(nodeId:any,e) {
    if(!this.rememberNodeArray.find(m=>m==nodeId))
       this.rememberNodeArray.push(nodeId);
       if(e.currentTarget.innerText=='arrow_drop_down'){
        this.rememberNodeArray= this.rememberNodeArray.filter(m=>m!=nodeId)
       }
  }

  createFolders(node) {
    const dialogRef = this.dialog.open(CreatefolderforFormComponent, {     
      data: {
       // formFolderID:node.formFolderID,
        parentID:node.formFolderID,
      }
    });
    dialogRef.afterClosed().subscribe(result => {  
      if(result != undefined && result!=null){
        this.getFormFolderList();
        if(this.selectedFolderID>0) 
          this.getFormFolderWithFormTemplates({formFolderID:this.selectedFolderID});
      }     
    });
  }

  

  //selected = 'option2';

  createNewFolder() {
    const dialogRef = this.dialog.open(CreatefolderforFormComponent, {
      data: {
        parentID: 0,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result != undefined && result!=null){   
        this.getFormFolderList();
        this.getFormFolderWithFormTemplatesLeft({formFolderID:0});  
      }else{      
      }
    });
  }

  prepareBreadcrumMenu(folder){
    this.breadCrumMenu.push({ label: folder.formFolderName,id:folder.formFolderID,icon: 'navigate_next' });
    //remove all siblings of cureent folder request.    
  }


  getFormFolderWithFormTemplates(form){
    sessionStorage.setItem('esignatureMenuActive','true');
    sessionStorage.setItem('esignatureMenuSharedActive','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=true;
    this.activeNode=form.formFolderID;
    this.router.navigate(['/esignature']);

    this.selectedFolderID=Number(form.formFolderID);
    var rqModel ={      
      formFolderID:form.formFolderID,
      formFolderName:"",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID:Number(this.databaseId),
    }
    this.formService.getFormFolderWithFormTemplates(rqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) { 
          if(this.responseHolder.data!=null){
            this.responseHolder.data.forEach(e => {
              e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
            });
          }         
           this.FormsubFolderFolderList = this.responseHolder.data;
           this.formService.GetParentFormFolderHierarchy(rqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConstant.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if(this.hierarchyList == null || this.hierarchyList == undefined){                
                  this.breadCrumMenu=[];                 
                  var folderDetails ={      
                   breadCrumMenu:this.breadCrumMenu,
                   FormsubFolderFolderList:this.FormsubFolderFolderList,
                   formFolderID:form.formFolderID,
                  }
                 this._dataSharingService.sendSelectedFolderContentFromLeftMenu(folderDetails);
                 this.parentID = form.parentID;              
                 this.ShowCreateButton=true;  
                }else{
                  this.breadCrumMenu=[];
                  this.hierarchyList.forEach(e => {
                   this.breadCrumMenu.push({ label: e.formFolderName,id:e.formFolderID,icon: 'navigate_next' });
                  });
                  var folderDetails ={      
                   breadCrumMenu:this.breadCrumMenu,
                   FormsubFolderFolderList:this.FormsubFolderFolderList,
                   formFolderID:form.formFolderID,
                  }
                 this._dataSharingService.sendSelectedFolderContentFromLeftMenu(folderDetails);
                 this.parentID = form.parentID;              
                 this.ShowCreateButton=true; 
                }                       
              }              
            }           
          });      
        }
        else {        
        }
      }
      else {      
      }
    });    
  
  }

  getFormFolderWithFormTemplatesLeft(form){
    sessionStorage.setItem('esignatureMenuActive','true');
    sessionStorage.setItem('esignatureMenuSharedActive','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=true;
    this.activeNode=form.formFolderID; 

    this.selectedFolderID=Number(form.formFolderID);
    var rqModel ={      
      formFolderID:form.formFolderID,
      formFolderName:"",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID:Number(this.databaseId),
    }
    this.formService.getFormFolderWithFormTemplates(rqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          if(this.responseHolder.data!=null){
            this.responseHolder.data.forEach(e => {
              e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
            });
          }
           this.FormsubFolderFolderList = this.responseHolder.data;
           this.formService.GetParentFormFolderHierarchy(rqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConstant.statusSuccess) {                
                 this.hierarchyList = response.data.hierarchy;
                 if(this.hierarchyList == null|| this.hierarchyList == undefined){
                  this.breadCrumMenu=[];                 
                  var folderDetails ={      
                   breadCrumMenu:this.breadCrumMenu,
                   FormsubFolderFolderList:this.FormsubFolderFolderList,
                   formFolderID:form.formFolderID,
                  }
                 this._dataSharingService.sendSelectedFolderContentFromLeftMenu(folderDetails);
                 this.parentID = form.parentID;              
                 this.ShowCreateButton=true;  
                 }else{
                  this.breadCrumMenu=[];
                  this.hierarchyList.forEach(e => {
                   this.breadCrumMenu.push({ label: e.formFolderName,id:e.formFolderID,icon: 'navigate_next' });
                  });
                  var folderDetails ={      
                   breadCrumMenu:this.breadCrumMenu,
                   FormsubFolderFolderList:this.FormsubFolderFolderList,
                   formFolderID:form.formFolderID,
                  }
                 this._dataSharingService.sendSelectedFolderContentFromLeftMenu(folderDetails);
                 this.parentID = form.parentID;              
                 this.ShowCreateButton=true;  
                 }                       
              }              
            }           
          });      
        }
        else {
        }
      }
      else {
      }
    });  
  }
 

  showFormsToggle() {
    this.showForms = !this.showForms;
  }

  getLeftMenuList() {
    sessionStorage.setItem('esignatureMenuActive','true');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu("");
    this.SharedWithMeactive=false;
    this.Formsactive=true;
    this.activeNode="";
  }
  
  
  getSharedWithMe() {
    this.SharedWithMeactive=true;
    this.Formsactive=false;
    this.activeNode="";
    sessionStorage.setItem('esignatureMenuActive','false');
    sessionStorage.setItem('esignatureMenuSharedActive','true');
    sessionStorage.setItem('isSharedWithMeForm','false');
    sessionStorage.setItem('isShared','false');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu("sharewithme"); 
  }

  showInbox() {
    sessionStorage.setItem('esignatureMenuActive','false');
    sessionStorage.setItem('esignatureMenuSharedActive','false');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.SharedWithMeactive=false;
    this.Formsactive=false;
    this.activeNode="";
  }
  
  showSent() {
    sessionStorage.setItem('esignatureMenuActive','false');
    sessionStorage.setItem('esignatureMenuSharedActive','false');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.SharedWithMeactive=false;
    this.Formsactive=false;
    this.activeNode="";
  }
  
  showDraft() {
    sessionStorage.setItem('esignatureMenuActive','false');
    sessionStorage.setItem('esignatureMenuSharedActive','false');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.SharedWithMeactive=false;
    this.Formsactive=false;
    this.activeNode="";
  }

  showTrash() {
    sessionStorage.setItem('esignatureMenuActive','false');
    sessionStorage.setItem('esignatureMenuSharedActive','false');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.SharedWithMeactive=false;
    this.Formsactive=false;
    this.activeNode="";
  }

  RenameFolders(form) {
    const dialogRef = this.dialog.open(EditfolderforFormComponent, {     
      data: {       
         formFolderName:form.formFolderName,
         formFolderID:form.formFolderID,
         parentID:form.parentID,
         type:1  //1-For Folder , 2-For Form
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result != undefined && result!=null){
        this.getFormFolderList();         
        this.getFormFolderWithFormTemplatesLeft({formFolderID:this.selectedFolderID})  
      }
    });
  }
  
  DeleteFolders(form) {
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {   
        let request = {
          id: form.formFolderID,  // FolderID  |  FormID
          itemType: 1//form.type   //{ 1- Folder, 2- Form}        
        };

       this.selectedRecordDeleteArray.push(request);

        var rqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
      }      
       this.formService.DeleteFormItems(rqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Folder Deleted successfully.', '', {
                timeOut: 1000,
              });
              this.getFormFolderList(); 
              this.getFormFolderWithFormTemplatesLeft({formFolderID:form.parentID})  
              this.selectedRecordDeleteArray=[];
            }
          }
        });
      }
    });
  }    


 

  getform(node,index) {
    this._dataSharingService.sendSelectedFolderFileForm(node.formFolderID);
  }


  // Template Gallery // 
  
  ShowNoRecordFound:boolean=false;

  templateGallery(templateRef: TemplateRef<any>) {
     var ForGlobalTemp=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      ForGlobalTemp= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(ForGlobalTemp.length > 0){
       this.ShowGlobalTemplateDelete = true;
      }else{
        this.ShowGlobalTemplateDelete = false;
    }

    this.currentTemplateIndex=0;
    this.ShowNoRecordFound=false;
    this.selectedCategoryID=1;
    this.currentTaskTemplateTab="Global";
    this.masterTemplateList=[];
    this.getCategoryListWithTemplate();
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'task_template',
    });
    sessionStorage.setItem('MasterTemplateWebForm','false');
    sessionStorage.setItem('MasterOrgTemplateWebForm','false');
    sessionStorage.setItem('MasterGlobalTemplateWebForm','false');        
  }

  currentTemplateIndex = 0;

  selectCategory(event:any,type:any, index: any){ 

    this.currentTemplateIndex = index;

    if(type=='Global'){
      this.GettemplateByCategoryID(event);
    }else{
     this.getOrganizationFormTemplateGalleryByID(event);
    }
  }

  GettemplateByCategoryID(id:any){
   var rqModel={
    categoryID:id,
    isAllTemplate:id=="0"?true:false,
    isCategoriesOnly:false
   }  
   this.selectedCategoryID=id;
    this.formService.GetFormTemplateCategories(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          if(this.responseHolder.data!=null){
            this.masterTemplateList=this.responseHolder.data.templates;
            if(this.masterTemplateList.length>0){
              this.ShowNoRecordFound=false;
            }else{
              this.ShowNoRecordFound=true;
             } 
          }
        }
      }
    });
  }

  getCategoryListWithTemplate(){
   var rqModel={
    categoryID:0,
    isAllTemplate:true,
    isCategoriesOnly:false
   }
    this.formService.GetFormTemplateCategories(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          if(this.responseHolder.data!=null){
            this.categoryList = this.responseHolder.data.categories.filter(x => x.isActive == true);            
            this.masterTemplateList = this.responseHolder.data.templates;            
            if(this.responseHolder.data.categories.length>0){
             // this.selectedCategoryID=this.responseHolder.data.categories.find(m=>m.selected==true).categoryID;
             }              
             if(this.masterTemplateList.length>0){
              this.ShowNoRecordFound=false;
            }else{
              this.ShowNoRecordFound=true;
             } 
            } 
         }
       }
    });
  }

  CopyAFormFromAOffice(form) {
    this.dialog.closeAll();
    // var TempName=form.formName;
    // var splitTempName = TempName.split('_');
    // if(splitTempName.length > 1){
    //   var number = splitTempName[1].substr(4, 1); ;
    //   if(number==""){  
    //     TempName = TempName+"1";
    //   }else{
    //     var no = Number(number)+1;
    //     TempName = TempName.substring(0, TempName.length - 1);
    //     TempName = TempName+no;
    //   }
    // }else{
    //   TempName = TempName+"_Copy";
    // }
    var ReqModel = {
      //formFolderId: 0,
      formId: Number(form.formID),
      rootFolderName:"",
      //formName: TempName,
      importFromUserID: form.templateCreatedby,
      importFromOfficeID:Number(form.officeID),
      importFromOrganizationID: Number(form.organizationID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      //MasterTemplateOrganizationID:Number(form.organizationID),
      databaseID: Number(this.databaseId),      
      officeID:this.myOfficeID,
      };
     this.loaderService.show();
     this.formService.copyAFormFromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success("Template imported successfully to My Forms folder");
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  CreateProjectFromMasterTemplate(form){  
    this.dialog.closeAll(); 
    var ReqModel = {
     formFolderId: 0,
     formId: form.formID,
     formName: form.name,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     MasterTemplateOrganizationID:Number(form.organizationID),
     databaseID: Number(this.databaseId),
     OfficeIDList:this.OfficeIDList,
     officeID:this.myOfficeID,
     importFromOrganizationID: Number(form.organizationID),
   };
    this.loaderService.show()
    this.formService.UseMasterTemplateForProject(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {  
         if(form.formType==1){        
         sessionStorage.setItem('projectID',response.data.projectID);
         sessionStorage.setItem('type','1');  // 1 for Project and 2 for Template         
         this.router.navigate(['/esignature/second']);         
         sessionStorage.setItem('isSharedWithMeForm','false'); 
         sessionStorage.setItem('MasterTemplatePDFForm','false');
         sessionStorage.setItem('MasterTemplateTabularForm','false');
         sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
         this._dataSharingService.sendSelectedModuleName('Forms');
         this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
         }else {
          let formSigningLink= window.location.href.split(window.location.pathname)[0]+"/request/tabularsignature?token="+response.data.token;
          window.open(formSigningLink, "_blank");           
         }
       } else {
         this.loaderService.hide();
       }
     } else {
       this.loaderService.hide();
     }
   });
   
  }

  EditMasterTemplate(form){
    this.dialog.closeAll();
    // For PDF Form 
    if(form.formType==FormTypes.PdfForm){        
      sessionStorage.setItem('categoryID',form.categoryID);
      sessionStorage.setItem('ProjectName',form.formName);
      sessionStorage.setItem('projectID',form.formID);
      sessionStorage.setItem('MasterTemplatePDFForm','true');
      sessionStorage.removeItem('FolderOpenId');
      sessionStorage.removeItem('FolderOpenName');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template
      this.router.navigate(['/esignature/third']);
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }

    // For Tabular Form 
    if(form.formType==FormTypes.TabularForm){     
      sessionStorage.setItem('categoryID',form.categoryID);
      sessionStorage.setItem('ProjectName',form.formName);
      sessionStorage.setItem('projectID',form.formID);
      sessionStorage.setItem('MasterTemplateTabularForm','true');
      sessionStorage.removeItem('FolderOpenId');
      sessionStorage.removeItem('FolderOpenName');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template 
      this.router.navigate(['/esignature/secondtabular']);
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }  
     
    // For Tabular Form 
    if(form.formType==FormTypes.HtmlForm){     
     sessionStorage.setItem('categoryID',form.categoryID);
     sessionStorage.setItem('ProjectName',form.formName);
     sessionStorage.setItem('HtmlId',form.formID);
     sessionStorage.setItem('MasterGlobalTemplateWebForm','true');
     sessionStorage.setItem('MasterOrgTemplateWebForm','false');     
     sessionStorage.removeItem('FolderOpenId');
     sessionStorage.removeItem('FolderOpenName');
     sessionStorage.setItem('type',(ProjectTempType.HtmlForm).toString());  // 1 for Project and 2 for Template 
     this.router.navigate(['/esignature/htmlform']);
     //sessionStorage.setItem('HeaderModuleName', 'Template');
     this._dataSharingService.sendSelectedModuleName('Forms');
     this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
   }   
  }


  EditOrganizationMasterTemplate(form){
    this.dialog.closeAll();
    // For PDF Form 
    if(form.formType==FormTypes.PdfForm){        
      sessionStorage.setItem('categoryID',form.categoryID);
      sessionStorage.setItem('ProjectName',form.formName);
      sessionStorage.setItem('projectID',form.formID);
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm','true');
      sessionStorage.removeItem('FolderOpenId');
      sessionStorage.removeItem('FolderOpenName');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template
      this.router.navigate(['/esignature/third']);
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }
    if(form.formType==FormTypes.HtmlForm){     
      sessionStorage.setItem('categoryID',form.categoryID);
      sessionStorage.setItem('ProjectName',form.formName);
      sessionStorage.setItem('HtmlId',form.formID);
      sessionStorage.setItem('MasterOrgTemplateWebForm','true');
      sessionStorage.setItem('MasterGlobalTemplateWebForm','false');      
      sessionStorage.removeItem('FolderOpenId');
      sessionStorage.removeItem('FolderOpenName');
      sessionStorage.setItem('type',(ProjectTempType.HtmlForm).toString());  // 1 for Project and 2 for Template 
      this.router.navigate(['/esignature/htmlform']);
     // sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }   
    // // For Tabular Form 
    // if(form.formType==FormTypes.TabularForm){     
    //   sessionStorage.setItem('categoryID',form.categoryID);
    //   sessionStorage.setItem('ProjectName',form.formName);
    //   sessionStorage.setItem('projectID',form.formID);
    //   sessionStorage.setItem('MasterTemplateTabularForm','true');
    //   sessionStorage.removeItem('FolderOpenId');
    //   sessionStorage.removeItem('FolderOpenName');
    //   sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template 
    //   this.router.navigate(['/esignature/secondtabular']);
    //   sessionStorage.setItem('HeaderModuleName', 'Template');
    //   this._dataSharingService.sendSelectedModuleName('Forms');
    //   this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    // }   
  }

  MoveTo(form) {
    var parentId=0;
    parentId= form.formFolderID;    
    const dialogRef = this.dialog.open(MovetoFormComponent, {
      data: {       
        Formid: form.formFolderID,
        parentId:parentId,
        isForm: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=undefined && result!=null){
        this.getFormFolderList();
        this.getFormFolderWithFormTemplatesLeft({formFolderID:result.newParentFolderSelected});            
        this.selectedRecordDeleteArray=[];
        this._dataSharingService.sendRefreshListForForm(true);       
        }     
    });
  }

  currentTaskTemplateTab = 'Global';

  getTabDetails(event) {
    this.currentTemplateIndex = 0;
    this.currentTaskTemplateTab = event.value;

    if(event.value=="Global" || event.index==0){

      var ForGlobalTemp=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      ForGlobalTemp= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(ForGlobalTemp.length > 0){
       this.ShowGlobalTemplateDelete = true;
      }else{
        this.ShowGlobalTemplateDelete = false;
      }

      this.getCategoryListWithTemplate();
     // this.showNew=true;
      //this.showExisting=false;
    }   
  
    if(event.value=="Organization" || event.index==1){

      var ForGlobalTemp=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      ForGlobalTemp= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin ||
      m.roleLevel == RoleLevel.OrganizationAdmin);
      if(ForGlobalTemp.length > 0){
       this.ShowGlobalTemplateDelete = true;
      }else{
        this.ShowGlobalTemplateDelete = false;
      }

      this.getOrganizationFormTemplateGallery();
     // this.showNew=false;
     // this.showExisting=true;   
    } 
  }

  getOrganizationFormTemplateGallery(){
    this.categoryList=[];
    var rqModel={
     isCategoriesOnly:false,
     isAllTemplate:true,
     categoryID:0,
     templateType: 2, //0 self,  3 office, 2 organization, 1 super admin
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     databaseID: Number(this.databaseId),
     officeIDList:this.OfficeIDList,
     officeID:this.myOfficeID,     
    }
     this.formService.getOrganizationFormTemplateGallery(rqModel).subscribe(response => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
            this.categoryList = this.responseHolder.data.categories.filter(x => x.isActive == true);         
             this.OrganizationTemplateList = this.responseHolder.data.templates;
             this.masterTemplateList = this.responseHolder.data.templates;           
            //  if(this.responseHolder.data.categories.length>0){
            //    this.selectedCategoryID=this.responseHolder.data.categories.find(m=>m.selected==true).categoryID;
            //   }              
              if(this.masterTemplateList.length>0){
               this.ShowNoRecordFound=false;
             }else{
               this.ShowNoRecordFound=true;
              } 
             } 
          }
        }
     });
   }


   getOrganizationFormTemplateGalleryByID(id:any){ 
    var isAllTemplate:boolean=false;  
    if(id==0){
      isAllTemplate=true;
    }else{
      isAllTemplate=false;
    }
    var rqModel={
      isCategoriesOnly:false,
      isAllTemplate:isAllTemplate,//false,
      categoryID:Number(id),
      templateType: 2, //0 self,  3 office, 2 organization, 1 super admin
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
    }  
    this.selectedCategoryID=id;
     this.formService.getOrganizationFormTemplateGallery(rqModel).subscribe(response => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
             this.categoryList = this.responseHolder.data.categories.filter(x => x.isActive == true); 
             this.OrganizationTemplateList=this.responseHolder.data.templates;
             this.masterTemplateList=this.responseHolder.data.templates;
             if(this.masterTemplateList.length>0){
               this.ShowNoRecordFound=false;
             }else{
               this.ShowNoRecordFound=true;
              } 
           }
         }
       }
     });
   }


   DeleteGlobalTemplate(form) {
    var message = `Are you sure you want to delete global template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.formID, // FolderID  |  FormID
          itemType: 2, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if(this.responseHolder.data == 1) {
              this.getCategoryListWithTemplate();
              this.toastr.success('Global Template Deleted successfully.', '', {
                timeOut: 3000,
              });              
            }
          }
        });
      }
    });
   }

   DeleteOrganizationTemplate(form) {
    var message = `Are you sure you want to delete organization template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.formID, // FolderID  |  FormID
          itemType: 2, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if(this.responseHolder.data == 1) {
              this.getOrganizationFormTemplateGallery();
              this.toastr.success('Organization Template Deleted successfully.', '', {
                timeOut: 3000,
              });              
            }
          }
        });
      }
    });
   }

   timeout = null;

   searchTemplate(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {        
        this.masterTemplateList = this.masterTemplateList.filter(i => i.formName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
        }, 500);
      } else {

      }
    } else {
      this.GettemplateByCategoryID(this.currentTemplateIndex);
     // this.searchTemplateName = "";  
      //this.getTaskTemplatesForSingleTask();    
    }
  }

}


interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID:number;
  parentID:number;
  isShared:boolean;
}

interface FoodNodeSharedWithMe {
  name: string;
  children?: FoodNodeSharedWithMe[];
  id:number;
  parentID:number;
  permissionType:number;
  isShared:boolean;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID:number;
  parentID:number;
  isShared:boolean;
}

interface ExampleFlatNodeharedWithMe {
  expandable: boolean;
  name: string;
  level: number;
  id:number;
  parentID:number;
  permissionType:number;
  isShared:boolean;
}


